import {cn, toAbsoluteUrl} from '_metronic/helpers'

export function Loading({imgClass = '', className}: {imgClass?: string; className?: string}) {
  return (
    <div
      className={cn('w-full h-full flex flex-col items-center justify-center gap-5', className)}
      style={{minHeight: '200px'}}
    >
      <img
        className={cn(imgClass)}
        src={toAbsoluteUrl('/media/logos/logo-main.png')}
        alt='BottomUP'
        style={{height: '36px', width: 'auto', objectFit: 'contain'}}
      />
      <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{
              width: '7px',
              height: '7px',
              borderRadius: '50%',
              background: '#E84040',
              animation: `bu-pulse 1.2s ease-in-out ${i * 0.2}s infinite`,
              display: 'inline-block',
            }}
          />
        ))}
      </div>
      <style>{`
        @keyframes bu-pulse {
          0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
          40% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  )
}
